import { datadogRum } from '@datadog/browser-rum';
import {
	PUBLIC_DATADOG_APP_ID,
	PUBLIC_DATADOG_CLIENT_TOKEN,
	PUBLIC_APP_ENV,
	PUBLIC_DATADOG_SERVICE_NAME,
} from '$env/static/public';

export const initDatadog = () => {
	datadogRum.init({
		applicationId: PUBLIC_DATADOG_APP_ID,
		clientToken: PUBLIC_DATADOG_CLIENT_TOKEN,
		site: 'us3.datadoghq.com',
		service: PUBLIC_DATADOG_SERVICE_NAME,
		env: PUBLIC_APP_ENV,
		defaultPrivacyLevel: 'mask-user-input',
	});
};
